export const fmt = (n, d = 2) => (n == null || Number.isNaN(n) ? "—" : Number(n).toLocaleString("en-IN", { maximumFractionDigits: d, minimumFractionDigits: 0 }));
export const inr = (n) => (n == null ? "—" : `₹${fmt(n, 0)}`);
export const usd = (n) => (n == null ? "—" : `$${fmt(n, 2)}`);

export const STATUS = {
  within: { label: "Within budget", dot: "bg-emerald-600", text: "text-emerald-600", bg: "bg-emerald-500/10" },
  approaching: { label: "Approaching budget", dot: "bg-amber-600", text: "text-amber-600", bg: "bg-amber-500/10" },
  over: { label: "Over budget", dot: "bg-rose-600", text: "text-rose-600", bg: "bg-rose-500/10" },
  no_budget: { label: "No daily budget set", dot: "bg-muted-foreground/50", text: "text-muted-foreground", bg: "bg-secondary" },
};

export const StatusPill = ({ status, testid }) => {
  const s = STATUS[status] || STATUS.no_budget;
  return <span data-testid={testid} className={`inline-flex items-center gap-1.5 rounded-full px-2 py-0.5 text-xs ${s.bg} ${s.text}`}><span className={`h-2 w-2 rounded-full ${s.dot}`} />{s.label}</span>;
};

export const Basis = ({ basis }) => {
  const est = basis !== "actual";
  return <span className={`rounded px-1.5 py-0.5 text-[10px] uppercase tracking-wider ${est ? "bg-amber-500/15 text-amber-600" : "bg-emerald-500/15 text-emerald-600"}`}>{basis === "mixed" ? "mixed" : est ? "estimated" : "actual"}</span>;
};

export const Card = ({ label, value, sub, tone, testid, children }) => (
  <div data-testid={testid} className="rounded-xl border bg-card p-4">
    <div className="text-[11px] uppercase tracking-wider text-muted-foreground">{label}</div>
    <div className={`text-2xl font-semibold mt-1 ${tone || ""}`}>{value}</div>
    {sub && <div className="text-xs text-muted-foreground mt-1">{sub}</div>}
    {children}
  </div>
);
